// ✅ External Libraries
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// ✅ Material UI Components
import { 
  Autocomplete, 
  Box, 
  IconButton, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TextField 
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

// ✅ Material UI Icons
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

// ✅ Custom Components
import PartNumberEdit from './PartNumberEdit';
import PartNumberRead from './PartNumberRead';
import ExcelDownload from '../../../data/exceldownload';

// ✅ API Slices
import { useGetconsumcatQuery } from '../../../features/consumcat/consumcatApiSlice';
import { useGetconsummasterQuery } from '../../../features/consummaster/consummasterApiSlice';
import { useGetbrandmasterQuery } from '../../../features/brandmaster/brandmasterApiSlice';
import { useGetModelNumbersQuery } from '../../../features/modelnumber/modelNumberApiSlice';

import { 
  useAddNewpartnumberMutation, 
  useDeletepartnumberMutation, 
  useGetpartnumberQuery, 
  useUpdatepartnumberMutation 
} from '../../../features/partnumber/partnumberApiSlice';

// ✅ Styled Components & Common Styles
import { HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import { TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';


const Addcategform = styled.form`
  display: flex;
  margin-bottom:6px;
`;

const Displaydiv1 = styled.div``;

const FormEleWrapper = styled.div``;

const Row1 = styled.div`
  display: flex;
  column-gap:20px;
  flex-grow:1;
  width: 100%;  
`;

const Row2 = styled.div`
  display: flex;
  margin-top:10px;
  width: 100%;
`;
const Wrapper1 = styled.div`
  flex-grow: 1;
`;

const Wrapper2 = styled.div`
  flex-grow: 1;
  min-width:250px;
`;

const Wrapper3 = styled.div`
  flex-grow: 1;
  min-width:250px;
`;

const Wrapper4 = styled.div`
  flex-grow: 1; 
  min-width:250px;
`;

const Wrapper5 = styled.div`
min-width:460px;
`;

const SubmitButtonWrapper = styled.div`
  display:flex;
  align-items:flex-end;
`;

const Button2Div =styled.div`
  display: flex;
  justify-content: end;
  align-items:flex-end;
`;

const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:0;
  margin-bottom:0;
`;

const ComplaintCategoryWrapper =styled.div`
  display: flex;
  align-items: center;
  justify-content:space-between;
`;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;

export default function PartNumber () {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedConsum, setSelectedConsum ] = useState({});
  

  const {consummaster} = useGetconsummasterQuery("consummaster", {
    selectFromResult: ({data}) => ({
      consummaster: data?.entities
    }),
  })
  const {consumcat} = useGetconsumcatQuery("consumcat", {
    selectFromResult: ({data}) => ({
      consumcat: data?.entities
    }),
  })
  const {brandmaster} = useGetbrandmasterQuery("brandmaster", {
    selectFromResult: ({data}) => ({
      brandmaster: data?.entities
    }),
  })
  const {modelnumber} = useGetModelNumbersQuery("modelmaster", {
    selectFromResult: ({data}) => ({
      modelnumber: data?.entities
    }),
  })

  const {partnumber} = useGetpartnumberQuery("partnumber", {
    selectFromResult: ({data}) => ({
      partnumber: data?.entities
    }), 
  })
  const [addNewPartNumber] = useAddNewpartnumberMutation();
  const [updatePartNumber] = useUpdatepartnumberMutation();
  const [deletePartNumber] = useDeletepartnumberMutation();


  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({
    id:"",
    partno:"",
    consumcategory:"",
    consumable:"",
    brand:"",
    assetModelNos:[], 
  });
  const [addPartNumber, setAddPartNumber] = useState({
    partno:"",
    consumcategory:"",
    consumable:"",
    brand:"",
    assetModelNos:[],
  });
  const [downloadData, setDownloadData] = useState({});

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    // 🛠️ Helper function to show alerts
    const showAlert = (message) => {
        alert(message);
    };

    // 🚦 Validation checks
    const validations = [
        { condition: !addPartNumber?.partno?.length, message: "Please enter a value for Part Number" },
        { condition: !addPartNumber?.consumcategory?.length, message: "Please select a value for Consumable Category" },
        { condition: !addPartNumber?.consumable?.length, message: "Please select a value for Applicable Consumable" },
        { condition: !addPartNumber?.brand?.length, message: "Please select a value for Brand" },
        {
            condition: !addPartNumber?.assetModelNos?.length && 
                       !selectedConsum?.asset?.includes("Not Applicable"),
            message: "Please select applicable Asset Model Nos"
        }
    ];

    // 🛑 Run through all validations and show the first alert if needed
    for (const { condition, message } of validations) {
        if (condition) return showAlert(message);
    }

    try {
        const foundPartNumber = partnumber 
            ? Object.values(partnumber).some(el => el.partno === addPartNumber.partno) 
            : false;

        if (foundPartNumber) {
            return showAlert(`Part Number "${addPartNumber.partno}" already exists`);
        }

        // 🆕 Add new part number if validation passes
        if (addPartNumber?.partno?.length) {
            await addNewPartNumber(addPartNumber);
            showAlert(`New Consumable "${addPartNumber.partno}" added to masters.`);
            setAddPartNumber({});
        }
        
    } catch (err) {
        console.error("Error adding part number:", err);
        showAlert("Failed to add part number. Please try again.");
    }

    setAddPartNumber({});
  };


  const onClickEdit = (e, index, row) => {
    const partData = partnumber?.[row?.id];
    if (!partData) return;

    // 🆕 Directly setting the form data with destructured values
    setEditFormData({
        id: row?.id,
        partno: partData?.partno,
        consumcategory: partData?.consumcategory,
        consumable: partData?.consumable,
        brand: partData?.brand,
        assetModelNos: partData?.assetModelNos
    });

    // 🔍 Setting the selected consumable
    const selected = Object.values(consummaster)?.find(x => x.consumable === partData?.consumable);
    setSelectedConsum(selected);

    // 🎯 Update the category index
    setEditCategory(index + 1);
  };


  const onChangePartNumber = (event, newValue, name) => {
    const temp = { ...addPartNumber };

    // 🖊️ Update from input event
    if (event?.target?.name) {
        temp[event.target.name] = event.target.value;
    }

    // 🆕 Update from Autocomplete or specific name
    if (name) {
        temp[name] = newValue;
    }

    // 🚦 Conditional Resets based on selection hierarchy
    switch (name) {
        case "consumcategory":
            temp.consumable = "";
            temp.brand = "";
            temp.assetModelNos = [];
            break;
        case "consumable":
            temp.brand = "";
            temp.assetModelNos = [];
            break;
        case "brand":
            temp.assetModelNos = [];
            break;
        default:
            break;
    }

    setAddPartNumber(temp);
  };

  //Edit has to bechecked. !!!! Not working properly.
  const onChangeEditPartNumber = (event, newValue, name) => {
    const tempEditFormData = { ...editFormData };

    // 🖊️ Update from input event
    if (event?.target?.name) {
        tempEditFormData[event.target.name] = event.target.value;
    }

    // 🆕 Update from Autocomplete or specific name
    if (name) {
        tempEditFormData[name] = newValue;
    }

    // 🚦 Conditional Resets based on selection hierarchy
    switch (name) {
        case "consumcategory":
            Object.assign(tempEditFormData, {
                consumable: "",
                brand: "",
                assetModelNos: [],
            });
            break;

        case "consumable":
            Object.assign(tempEditFormData, {
                brand: "",
                assetModelNos: [],
            });
            break;

        case "brand":
            tempEditFormData.assetModelNos = [];
            break;

        default:
            break;
    }

    setEditFormData(tempEditFormData);
  };


  const handleEditFormSubmit = async (e) => {
    e.preventDefault();

    const {
        partno = "",
        consumcategory = "",
        consumable = "",
        brand = "",
        assetModelNos = [],
        id,
    } = editFormData || {};

    // 🚦 **Validation Checks**  
    if (!partno || !consumcategory || !consumable || !brand) {
        alert("Please enter valid values before submitting.");
        return;
    }

    if (!assetModelNos.length && !selectedConsum?.asset?.includes("Not Applicable")) {
        alert("Please select applicable Asset Model Nos.");
        return;
    }

    // ❌ **Duplicate Check**  
    const partNumbers = Object.values(partnumber).filter(item => item._id !== id).map(item => item.partno);
    if (partNumbers.includes(partno)) {
        alert("Part Number already exists in the database.");
        return;
    }

    // 🚀 **Submit Data**  
    try {
        setEditCategory(null);
        const response = await updatePartNumber(editFormData);
        alert(response?.data?.message || "Part Number updated successfully.");
    } catch (err) {
        console.error("Error updating part number:", err);
        alert("Failed to update part number. Please try again.");
    }
  };

  const getAssetModelOptions = ({
    modelnumber, 
    addPartNumber, 
    selectedConsum, 
    setAddPartNumber
}) => {
    if (!modelnumber || !selectedConsum) return [];

    const { assetModelNos } = addPartNumber;
    const { asset: consumableAssets } = selectedConsum;

    // Step 1: Filter models by applicable assets
    let filteredModels = Object.values(modelnumber).filter(model => 
        consumableAssets.includes(model.asset)
    );

    // Step 2: Generate "All-Asset" and "All-Asset-Brand" options
    const addAssetArray = consumableAssets.map(asset => `All-${asset}`);
    const addAssetBrandArray = Array.from(
        new Set(filteredModels.map(model => `All-${model.asset}-${model.brand}`))
    );

    // All available model numbers
    const allModelNos = filteredModels.map(model => model.modelno);

    // Step 3: Determine selected "All-..." options
    const selectedAllOptions = assetModelNos.filter(item => item.startsWith("All-"));

    let excludedModelNos = new Set();
    let excludedBrandOptions = new Set();

    // Step 4: Handle "All-..." selections and deselect conflicting model numbers
    selectedAllOptions.forEach(option => {
        const [_, asset, brand] = option.split("-");

        filteredModels.forEach(model => {
            const isAssetMatch = model.asset === asset;
            const isBrandMatch = brand ? model.brand === brand : true;

            // Exclude model numbers for both "All-Asset" and "All-Asset-Brand" selections
            if (isAssetMatch && isBrandMatch) {
                excludedModelNos.add(model.modelno);
            }
        });

        // Exclude "All-Asset-Brand" options if "All-Asset" is selected
        if (!brand) {
            addAssetBrandArray.forEach(brandOption => {
                if (brandOption.startsWith(`All-${asset}-`)) {
                    excludedBrandOptions.add(brandOption);
                }
            });
        }
    });

    // Step 5: Update selected model numbers to deselect conflicting ones
    const updatedSelectedModelNos = assetModelNos.filter(option => {
        // Retain only those model numbers not excluded by "All-..." selections
        if (allModelNos.includes(option)) {
            return !excludedModelNos.has(option);
        }
        return true;
    });

    // Step 6: Set the updated state
    if (updatedSelectedModelNos.length !== assetModelNos.length) {
        setAddPartNumber(prev => ({
            ...prev,
            assetModelNos: updatedSelectedModelNos
        }));
    }

    // Step 7: Final available options excluding selected "All-..." model numbers and brand options
    const availableOptions = [
        ...addAssetArray.filter(option => !selectedAllOptions.includes(option)),
        ...addAssetBrandArray.filter(option => !excludedBrandOptions.has(option)),
        ...allModelNos.filter(modelNo => !excludedModelNos.has(modelNo))
    ];

    console.log("Available Options:", availableOptions);
    console.log("Updated Selected Model Numbers:", updatedSelectedModelNos);

    return availableOptions;
  };



  const handleCancelClick = () => {
    setEditFormData({
        id: "",
        partno: "",
        consumcategory: "",
        consumable: "",
        brand: "",
        assetModelNos: []
    });
    setEditCategory(null);
  };


  const handleDeleteClick = async (e, row) => {
    e.preventDefault();

    const { id, partno } = row;

    if (!window.confirm(`Do you want to delete Part Number "${partno}"?`)) return;

    try {
        await deletePartNumber({ id });
        alert(`Part Number "${partno}" deleted successfully.`);
    } catch (error) {
        console.error("Failed to delete Part Number:", error);
        alert("An error occurred while deleting the Part Number. Please try again.");
    }
  }; 

  useEffect(() => {
    if (!partnumber) return;

    setTabledata(Object.values(partnumber));
  }, [partnumber]);



//Setting the download data for excel download.
useEffect(() => {
  if (!tabledata?.length) return;

  const keyOrderArray = ["partno", "consumcategory", "consumable", "brand", "assetModelNos"];

  // Step 1: Clone and transform data
  const finalDownloadData = tabledata.map(({ _id, ...others }) => ({
      ...others,
      partno: others.partno,
      consumcategory: others.consumcategory,
      consumable: others.consumable,
      brand: others.brand,
      assetModelNos: others.assetModelNos
  }));

  // Step 2: Sort keys according to `keyOrderArray`
  const finalSortedDownloadData = finalDownloadData.map(item =>
      keyOrderArray.reduce((acc, key) => ({ ...acc, [key]: item[key] }), {})
  );

  setDownloadData(finalSortedDownloadData);
}, [tabledata]);


useEffect(() => {
  if (consummaster) {
    setSelectedConsum(Object.values(consummaster)?.find(x => x.consumable === addPartNumber.consumable));
  }
},[consummaster, addPartNumber.consumable])

 
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap style={{marginBottom:"20px"}}>
        <Span>Add New Consumable Part Number</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>
        <FormEleWrapper>
          <Row1>
          <Wrapper1>  
            <TextField
              id="outlined-basic"
              size='small'
              name='partno'
              onChange={(event, newValue) => onChangePartNumber(event, newValue)}
              label="Enter a New Part Number"
              value={addPartNumber?.partno || ""}
              variant="outlined"
              sx={{backgroundColor:"white", height:"40px"}}
            />
            </Wrapper1>
            <Wrapper2>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disablePortal
                id="combo-box-demo"
                size='small'
                value={addPartNumber.consumcategory || "" }
                onChange={(event, newValue) => onChangePartNumber(event, newValue, "consumcategory")}
                options={consumcat? Object.values(consumcat)?.map(x => x?.name): []}
                sx={{backgroundColor:"white",height:"40px"}}
                renderInput={(params) => <TextField {...params} label={"Select Consumable Category"} />}
              />
            </Wrapper2>
            <Wrapper3>
              <Autocomplete
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                disablePortal
                id="combo-box-demo"
                size='small'
                value={addPartNumber.consumable || "" }
                onChange={(event, newValue) => onChangePartNumber(event, newValue, "consumable")}
                options={consummaster? Object.values(consummaster).filter( a => a?.consumcategory === addPartNumber?.consumcategory ).map(x => x.consumable):[]}
                sx={{backgroundColor:"white",height:"40px"}}
                renderInput={(params) => <TextField {...params} label={"Select Consumable"} />}
              />
            </Wrapper3> 
            <Wrapper4> 
              <Autocomplete
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                disablePortal
                id="combo-box-demo"
                size='small'
                value={addPartNumber.brand || "" }
                onChange={(event, newValue) => onChangePartNumber(event, newValue, "brand")}
                options={brandmaster? Object.values(brandmaster).map(x => x.name) :[]}
                sx={{backgroundColor:"white",height:"40px"}}
                renderInput={(params) => <TextField {...params} label={"Brand"} />}
              />
            </Wrapper4>
          </Row1>            
          
          {(addPartNumber?.brand?.length && !selectedConsum?.asset?.includes("Not Applicable"))?<Row2>
            <Wrapper5>
              <Autocomplete
                multiple
                id="combo-box-demo"
                size='small'
                options={getAssetModelOptions({
                  modelnumber,
                  addPartNumber,
                  selectedConsum,
                  setAddPartNumber
                })}
                sx={{backgroundColor:"white",height:"40px"}}
                value={addPartNumber?.brand?.length? addPartNumber.assetModelNos:[]}
                onChange={(event, newValue) =>onChangePartNumber(event, newValue, "assetModelNos")}
                renderInput={(params) => ( 
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Select Asset Model Nos"
                    placeholder="Favorites"
                  />
                )}
              />
            </Wrapper5>
          </Row2>:null}                 
        </FormEleWrapper>
        <SubmitButtonWrapper>
          <SubmitButton type='submit'>Submit</SubmitButton>
        </SubmitButtonWrapper>       
        <Button2Div>
          <ExcelDownload data={downloadData} filename={"partnumber"} sheetName={"sheet1"} />
        </Button2Div> 
      </Addcategform>
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"4%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Part Number</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"16%"}}} align="left">Consumable Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Consumable</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Brand</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Asset Model No</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?

                              
               <PartNumberEdit row={row} k={key} editFormData={editFormData} handleCancelClick={handleCancelClick} page={page} consumcat={consumcat}
                rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditPartNumber={onChangeEditPartNumber} SubmitButton ={SubmitButton} selectedConsum={selectedConsum} 
                consummaster={consummaster} brandmaster={brandmaster} modelnumber={modelnumber} getAssetModelOptions ={getAssetModelOptions}
                setEditFormData = {setEditFormData}
               />

                :<PartNumberRead row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} tableFontSize={tableFontSize} SubmitButton ={SubmitButton}             
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>    
    </Displaydiv1>
    </>
  );
}